<template>
  <div class="user-profile-drop-down-content">
    <!-- <b-dropdown-item>
      <router-link
        class="btn btn-block btn-outline-primary flat-button mb-3"
        :to="{ name: 'user-profile' }"
        @click.capture="$emit('close')"
      >
        Editar perfil
      </router-link>
    </b-dropdown-item> -->

    <b-dropdown-item>
      <router-link
        :to="{ name: 'user-personal-data' }"
        @click.capture="$emit('close')"
      >
        <span>Dados Pessoais</span>
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item>
      <router-link
        :to="{ name: 'user-financial-data' }"
        @click.capture="$emit('close')"
      >
        <span>Dados Financeiros</span>
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item v-if="info.refer_url">
      <button @click="copyLink">
          <span>Copiar Link (Indique & Ganhe)</span>
      </button>
    </b-dropdown-item>
    <!-- <b-dropdown-item>
      <router-link
        class="btn btn-item justify-content-start"
        :to="{ name: 'achievements' }"
        @click.capture="$emit('close')"
      >
        <i class="icon-trophy mr-3" />
        <strong>Conquistas</strong>
      </router-link>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item>
      <router-link
        class="btn btn-item justify-content-start"
        :to="{ name: 'user-preferences' }"
        @click.capture="$emit('close')"
      >
        <i class="icon-settings mr-3" />
        <strong>Preferências</strong>
      </router-link>
    </b-dropdown-item> -->
    <!-- <router-link
      class="btn btn-item justify-content-start"
      :to="{ name: 'user-personal-data' }"
      disabled
    >
      <i class="icon-user mr-3" />
      <strong>Informações Pessoais</strong>
    </router-link> -->
    <b-dropdown-item>
      <button @click="$emit('logout')">
        <span>Sair</span>
      </button>
    </b-dropdown-item>
  </div>
</template>

<script>
export default {
  computed: {
    info() {
      if (!this.$user.user) return { name: "", email: "" };

      return this.$user.user;
    }
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.info.refer_url);
    }
  }
};
</script>

<style lang="scss" scoped>
.user-profile-drop-down-content {
  padding: 24px;
  .flat-button {
    min-height: 28px;
    max-height: 28px;
  }

  .avatar-profile {
    border: 1px solid #5576ec;
    border-radius: 50%;
    position: relative;

    img {
      width: 50px;
      height: 50px;
      object-fit: cover;
      border-radius: 50%;
      margin: 2px;
    }
  }

  i {
    font-size: 16px;
    color: rgba(59, 59, 74, 0.9);
  }

  span {
    font-weight: 500;
    font-size: 14px;
    color: rgba(59, 59, 74, 0.9);
  }

  .fa-wallet {
    margin-right: 6px;
  }

  small {
    word-break: break-word;
    font-weight: 400;
  }

  hr {
    margin: 1px 0;
    background-color: rgba(208, 209, 221, 0.85);
    opacity: 0.2;
  }

  button,
  a {
    width: 100%;
    padding: 6px 8px;
    font-size: 14px;
    color: var(--dark);
    border-radius: 12px;
    align-items: center;
    background-color: transparent;
    text-align: left;
    border: none;
    display: block;

    transition: 0.2s all;
    &.router-link-exact-active,
    &:hover {
      background: var(--dark-4);
      text-decoration: none;
      color: var(--dark);
    }
  }
  ::v-deep li {
    list-style: none;
  }
  ::v-deep.dropdown-item {
    padding: 0;
    &:hover {
      background: transparent;
    }
    &:active {
      background: rgba(0, 0, 0, 0.1);
    }
  }

  .card {
    margin: -12px;
    margin-bottom: 12px;
    border-radius: 0px;
    border: none;
    overflow: hidden;

    .card-body {
      padding: 12px;
    }
  }
}
</style>
